// extracted by mini-css-extract-plugin
export default {"wrapper":"PageWrapper_wrapper__WKdx3","content":"PageWrapper_content__FA+cv","footer":"PageWrapper_footer__dmLyv"};